import lessRequire from '../../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import classname from 'classname';

lessRequire('modules/statistics/components/column-control/form/checkbox-show-conditions.less');

const ShowConditions = props => {
	const className = classname({
		'checkbox-show-conditions__wrap': true,
		'is-init': props.type === 'init',
		'is-less': props.type === 'less',
		'is-large': props.type === 'large',
		'is-disabled': props.type === 'disabled'
	});

	return (
		<div className="checkbox-show-conditions">
			<div className={className}>
				<input
					type="checkbox"
					id={props.input.name}
					checked={!!props.input.value}
					disabled={props.type === 'disabled'}
					{...props.input}
				/>
				<label htmlFor={props.input.name} />
			</div>
			{(props.labelText &&
				(props.type === 'less' || props.type === 'large') &&
				<div className="checkbox-show-conditions__meta">
					<label htmlFor={props.input.name} className="label-text">
						{props.labelText}
					</label>

					<a
						href="#"
						className="icon-clear"
						onClick={e => {
							e.preventDefault();
							props.onClear();
						}}
					/>
				</div>) ||
				null}
		</div>
	);
};

ShowConditions.propTypes = {
	type: PropTypes.oneOf(['init', 'less', 'large', 'disabled']),
	input: PropTypes.object,
	labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClear: PropTypes.func
};

export default ShowConditions;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/column-control/form/checkbox-show-conditions.js